import { Icon, Modal } from 'Components';
import styles from './UInassignTrainingModal.module.scss';
import Button from '../Button';

interface UnassignTrainingModalProps {
	visible: boolean;
	onSubmit: () => void;
	onCancel: () => void;
	loading?: boolean;
	// bulk assignment mode
	assignmentCount?: number;
	learnerCount?: number;
	// course mode
	courseCount?: number;
}
const UnassignTrainingModal: React.FC<UnassignTrainingModalProps> = ({
	visible,
	onSubmit,
	onCancel,
	loading = false,
	assignmentCount,
	learnerCount,
	courseCount
}) => {
	const isBulk = assignmentCount !== undefined;
	const isCourse = courseCount !== undefined;
	const hasNoLearners = isBulk && learnerCount === 0;

	return (
		<Modal
			visible={visible}
			onCancel={loading ? undefined : onCancel}
			closable={!loading}
			maskClosable={!loading}
			className={styles.unassignModalRoot}
			footer={
				<div className={styles.unassignModal__actions}>
					<Button
						variant="borderless"
						size="small"
						onClick={onCancel}
						disabled={loading}
					>
						Cancel
					</Button>
					<Button
						size="small"
						onClick={onSubmit}
						loading={loading}
						disabled={hasNoLearners}
					>
						Unassign
					</Button>
				</div>
			}
			centered
			size="xs"
		>
			<div className={styles.unassignModal}>
				<div className={styles.unassignModal__title}>
					{isCourse ? 'Unassign courses?' : 'Unassign training?'}
				</div>

				{isCourse ? (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							Unassigning this courses will:
						</div>
						<ul className={styles.unassignModal__list}>
							<li>Affect {learnerCount ?? 0} learners total</li>
						</ul>
					</div>
				) : isBulk ? (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							Unassigning this training will:
						</div>
						<ul className={styles.unassignModal__list}>
							<li>Affect {assignmentCount} assignment{assignmentCount !== 1 ? 's' : ''}</li>
							<li>
								Affect{' '}
								{learnerCount === undefined ? (
									<Icon type="loading" aria-label="Counting users" />
								) : (
									`${learnerCount} learner${
										learnerCount === 1 ? '' : 's'
									}`
								)}{' '}
								total
							</li>
						</ul>
						{hasNoLearners && (
							<div className={styles.unassignModal__description}>
								None of the selected assignments have learners that
								can be unassigned.
							</div>
						)}
					</div>
				) : (
					<div className={styles.unassignModal__wrapper}>
						<div className={styles.unassignModal__description}>
							This training is currently assigned, but no learners
							have started it yet.
						</div>
						<div className={styles.unassignModal__description}>
							Unassigning will remove this training from all assigned
							learners. No progress, completions, or scores will be
							affected.
						</div>
					</div>
				)}

				<div className={styles.unassignModal__warning}>
					<Icon type="warningFilledIcon" role="img" />
					{isCourse
						? 'This action cannot be undone. All progress data will be lost.'
						: 'This action is permanent and cannot be undone'}
				</div>
			</div>
		</Modal>
	);
};

export default UnassignTrainingModal;
